/**
 * Common types used across the application
 */

// UUID type alias for better type safety
export type UUID = string;

// Timestamp types
export interface Timestamps {
  created_at: string;
  updated_at: string;
}

// Base entity with common fields
export interface BaseEntity extends Timestamps {
  id: UUID;
}

// Generic status enum
export enum Status {
  ACTIVE = "active",
  INACTIVE = "inactive",
  PROSPECT = "prospect",
  PENDING = "pending",
  ARCHIVED = "archived",
}

// Pagination parameters
export interface PaginationParams {
  page: number;
  limit: number;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  search?: string;
}

// Paginated response wrapper
export interface PaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

// API error response
export interface ApiError {
  message: string;
  code?: string;
  details?: Record<string, unknown>;
}

// File upload metadata
export interface FileMetadata {
  name: string;
  size: number;
  type: string;
  url?: string;
}

// Address type
export interface Address {
  street1: string;
  street2?: string;
  city: string;
  state: string;
  postal_code: string;
  country: string;
}

// Contact information
export interface ContactInfo {
  email?: string;
  phone?: string;
  mobile?: string;
  fax?: string;
}

// Audit log entry
export interface AuditLog extends BaseEntity {
  entity_type: string;
  entity_id: UUID;
  action: "create" | "update" | "delete";
  user_id: UUID;
  changes: Record<string, unknown>;
  ip_address?: string;
}
